import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { AiFillWarning } from "react-icons/ai";
import { BsEyeSlash } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";

const ResetPassword = () => {
  const [passwordType, setPasswordType] = useState("password");
  const [confirmPasswordType, setConfirmPasswordType] = useState("password");
  const [errorText, setErrorText] = useState("");
  
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const password = watch("password");

  const togglePassword = () => {
    setPasswordType(passwordType === "password" ? "text" : "password");
  };

  const toggleConfirmPassword = () => {
    setConfirmPasswordType(confirmPasswordType === "password" ? "text" : "password");
  };

  const onSubmit = (data) => {
    console.log("New Password:", data.password);
    console.log("Confirm Password:", data.confirmPassword);
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5}>
          <div className="reset-password-card p-4">
            <h2 className="text-center mb-4">Reset Password</h2>
            <p className="text-center mb-4 text-muted">
              Please enter your new password below
            </p>
            
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="mb-4 position-relative">
                <Form.Label>New Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={passwordType}
                    placeholder="Enter new password"
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters"
                      }
                    })}
                  />
                  <div className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
                    {passwordType === "password" ? (
                      <BsEyeSlash onClick={togglePassword} />
                    ) : (
                      <AiOutlineEye onClick={togglePassword} />
                    )}
                  </div>
                </div>
                {errors.password && (
                  <div className="error mt-2">
                    <AiFillWarning fill="red" size={10} /> {errors.password.message}
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-4 position-relative">
                <Form.Label>Confirm New Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={confirmPasswordType}
                    placeholder="Confirm new password"
                    {...register("confirmPassword", {
                      required: "Please confirm your password",
                      validate: value =>
                        value === password || "Passwords do not match"
                    })}
                  />
                  <div className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
                    {confirmPasswordType === "password" ? (
                      <BsEyeSlash onClick={toggleConfirmPassword} />
                    ) : (
                      <AiOutlineEye onClick={toggleConfirmPassword} />
                    )}
                  </div>
                </div>
                {errors.confirmPassword && (
                  <div className="error mt-2">
                    <AiFillWarning fill="red" size={10} /> {errors.confirmPassword.message}
                  </div>
                )}
              </Form.Group>

              {errorText && (
                <div className="error mb-3">
                  <AiFillWarning fill="red" size={10} /> {errorText}
                </div>
              )}

              <Button 
                variant="primary" 
                type="submit" 
                className="w-100 py-2"
                style={{ backgroundColor: '#0055B8', border: 'none' }}
              >
                Reset Password
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword; 